.selectionList {
  max-height: 400px;
  overflow: auto;
}
